<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArchive } from "@mdi/js";
export default {
  name: "MdiArchive",
  data() {
    return {
      svgPath: mdiArchive,
    };
  },
};
</script>
